import React from 'react';
import { CharacterStats, StatType } from '../../../../../shared/CharacterTypes';
import { getStatAbbreviation, getStatDescription } from './StatHelpers';
import { TomeChapter } from '../../../primitives/tome';
import { StatLedgerRow } from './StatLedgerRow';

interface UtilityStatsPanelProps {
  stats: CharacterStats;
  characterClass?: string;
}

const UTILITY_STATS = [
  { stat: StatType.ACCURACY, label: 'Accuracy' },
  { stat: StatType.AVOIDABILITY, label: 'Avoidability' },
  { stat: StatType.SPEED, label: 'Speed' },
  { stat: StatType.JUMP, label: 'Jump' },
] as const;

export const UtilityStatsPanel: React.FC<UtilityStatsPanelProps> = ({ stats, characterClass }) => (
  <TomeChapter className="character-stat-section" title="Utility">
    <p className="character-stat-section__intro">Current synced hit, dodge, and movement ratings.</p>
    <div className="character-stat-list" role="list">
      {UTILITY_STATS.map(({ stat, label }) => (
        <StatLedgerRow
          key={stat}
          statType={stat}
          stats={stats}
          characterClass={characterClass}
          abbreviation={getStatAbbreviation(stat)}
          label={label}
          value={stats[stat]}
          description={getStatDescription(stat)}
        />
      ))}
    </div>
  </TomeChapter>
);
